const config = {
    corpId: process.env.QYWX_APP_CORP_ID || 'ww6f042e6eb6852dba',
    agentId: process.env.QYWX_APP_AGENT_ID || '1000005',
    miniprogramAppId: process.env.QYWX_MINI_APP_ID || 'wxcfe11652160b5ef7',
};

export default config;
